import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bool, func } from 'prop-types'
import { productsDataType } from 'models/propTypes'

import { requestFurniture as requestFurnitureAction } from 'models/furniture/actions'

import { getFurnitureByFilter, getFurnitureIsLoading, getCanLoadMore } from 'models/furniture/selectors'

import Products from 'components/designSidepanel/Products'

const ProductsContainer = ({ furnituresData, isInMyItems, furnitureIsLoading, canLoadMore, requestFurniture }) => {
    useEffect(() => {
        if (!(furnituresData && furnituresData.length) && !furnitureIsLoading && requestFurniture) {
            // Load initial furniture
            requestFurniture()
        }
    }, [])

    return (
        <Products
            furnituresData={furnituresData}
            isInMyItems={isInMyItems}
            furnitureIsLoading={furnitureIsLoading}
            requestFurniture={canLoadMore ? requestFurniture : null}
        />
    )
}

ProductsContainer.defaultProps = {
    isInMyItems: false,
}

ProductsContainer.propTypes = {
    furnituresData: productsDataType.isRequired,
    isInMyItems: bool,
    furnitureIsLoading: bool.isRequired,
    canLoadMore: bool.isRequired,
    requestFurniture: func.isRequired,
}

const mapStateToProps = (state) => ({
    furnituresData: getFurnitureByFilter(state),
    furnitureIsLoading: getFurnitureIsLoading(state),
    canLoadMore: getCanLoadMore(state),
})

const mapDispatchToProps = {
    requestFurniture: requestFurnitureAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductsContainer)
